export default __webpack_public_path__ + "static/media/library_dark.87c30c03.svg";